export enum GamesAPIRoutes {
    GET_GAME_ENGINES = "games:engines:versions:query",
    GET_GAME_ENGINES_SCHEMAS = "games:engines:query",
    GET_GAME_CONFIGS = "games:configuration:query",
    //GET_GAME_CONFIGURATION = "games:configuration:fetch",
    GET_SUBSIDIARIES = "subsidiary:query",
    GET_GAMES = "games:games:query",
    EDIT_GAME = "games:game:edit",
    ADD_GAME = "game:create",
    GET_GAME = "games:game:fetch",
    ADD_CONFIGURATION = "games:configuration:create",
    EDIT_CONFIGURATION = "games:configuration:edit",
    DELETE_CONFIGURATION = "games:configuration:delete",
    GET_BUNDLES = "games:bundle:query",
    ADD_BUNDLE = "games:bundle:create",
    EDIT_BUNDLE = "games:bundle:edit",
    DELETE_BUNDLE = "games:bundle:delete",
    LOAD_JSON = "games:configuration:load",
    CREATE_ALIAS = "games:alias:create",
    ACTIVATE_CONFIGURATION = "games:configuration:activate",
    GET_GAME_FEATURES = "games:features:query",
    CREATE_GAME_FEATURES = "games:features:create",
    EDIT_GAME_FEATURES = "games:features:edit",
    GET_GAME_SERIES = "games:series:query",
    CREATE_GAME_SERIES = "games:series:create",
    EDIT_GAME_SERIES = "games:series:edit",
    GET_GAME_PLATFORMS = "games:platforms:query",
    CREATE_GAME_PLATFORMS = "games:platforms:create",
    EDIT_GAME_PLATFORMS = "games:platforms:edit",
    GET_GAME_TYPES = "games:types:query",
    CREATE_GAME_TYPES = "games:types:create",
    EDIT_GAME_TYPES = "games:types:edit",
    GET_GAME_TRADEMARKS = "games:trademarks:query",
    CREATE_GAME_TRADEMARKS = "games:trademarks:create",
    EDIT_GAME_TRADEMARKS = "games:trademarks:edit",
    GET_CLIENTS = "games:clients:query"
}
